<div class="title">
  <div class="title__content" routerLink="dashboard">
    <img
      class="title__logo"
      src="./assets/img/logo.svg"
      width="44"
      height="44"
      alt="logo"
    />
    <div
      [innerHTML]="'trader-navigation.header.title' | translate"
      class="title__text"
    ></div>
  </div>
</div>

<button
  *ngIf="(sidebarVisible$ | async) !== true"
  (click)="showSidebar()"
  type="button"
  class="menu-button"
>
  <ng-container *ngTemplateOutlet="icon"></ng-container>
</button>
<button
  *ngIf="sidebarVisible$ | async"
  (click)="hideSidebar()"
  type="button"
  class="menu-button menu-button--active"
>
  <ng-container *ngTemplateOutlet="icon"></ng-container>
</button>

<ng-template #icon>
  <svg viewBox="0 0 30 30" class="icon">
    <rect width="30" height="2" class="bar bar--top"></rect>
    <rect width="30" height="2" class="bar bar--middle" y="10"></rect>
    <rect width="30" height="2" class="bar bar--bottom" y="20"></rect>
  </svg>
</ng-template>
